import { KeyValuePair } from '../types';
export interface BuildPcCategory {
  name: string;
  id: string;
  icon: string;
}
export const CategoryRepository = {
  all(): Array<BuildPcCategory> {
    return [
      {
        name: 'Vi xử lý',
        id: '553',
        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/cpu.svg?alt=media&token=77cbc8d7-f570-45a4-8bee-8d87265e39fd',
      },
      {
        name: 'Bo mạch chủ',
        id: '552',
        icon: 'http://static.360buyimg.com/master-of-loader/pc/img/mother-board-icon.82595f5e.svg',
      },
      {
        name: 'RAM',
        id: '548',
        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/ram.svg?alt=media&token=2ed78d9a-5622-4be9-9ef7-e7c53e3ac544',
      },
      {
        name: 'Ổ HDD',
        id: '1861',
        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/hdd.svg?alt=media&token=05efe4a2-d30e-4f2f-8493-f61eea388840',
      },
      {
        name: 'Ổ SSD',
        id: '637',
        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/ssd.svg?alt=media&token=e4be0398-ae2a-4735-b2aa-240c46039abe',
      },
      {
        name: 'VGA',
        id: '554',
        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/vga-card.svg?alt=media&token=9f112617-13ac-4016-aa3b-6f03d53a9f9a',
      },
      {
        name: 'Nguồn',
        id: '541',
        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/power-supply.svg?alt=media&token=47f2d1e9-6927-4778-917d-cb52e7d0b027',
      },
      {
        name: 'Vỏ case',
        id: '549',
        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/server.svg?alt=media&token=66b99bc2-7d47-4dd7-a1bb-b22976b54b41',
      },
      {
        name: 'Tản nhiệt',
        id: '555',

        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/fan.svg?alt=media&token=726a4f32-3cb8-4bff-ad7b-0428414f1443',
      },
      {
        name: 'Màn hình',
        id: '540',

        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/monitor.svg?alt=media&token=9382ecd3-da49-4542-a9b5-8d8eb0a07128',
      },
      {
        name: 'Bàn phím',
        id: '543',

        icon: 'http://static.360buyimg.com/master-of-loader/pc/img/keyboard-icon.87b45d1c.svg',
      },
      {
        name: 'Chuột',
        id: '542',

        icon: 'http://static.360buyimg.com/master-of-loader/pc/img/mouse-icon.144f4d99.svg',
      },
      {
        name: 'Tai nghe',
        id: '972',

        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/headphones.svg?alt=media&token=ca5310b8-dc9f-4c2e-9b51-54c07fb4327c',
      },
      {
        name: 'Loa máy tính',

        id: '905',
        icon: 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/windows-media-audio.svg?alt=media&token=7d43a7d7-6834-4ecf-99eb-5edfce667300',
      },
    ];
  },
  allById(): KeyValuePair {
    const categoryDict: KeyValuePair = {};
    this.all().forEach((category: BuildPcCategory) => {
      categoryDict[category.id] = category.name;
    });
    return categoryDict;
  },
};
